Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkedInBadge = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var LinkedInBadge = function LinkedInBadge(_ref) {
  var username = _ref.username,
    _ref$badgeType = _ref.badgeType,
    badgeType = _ref$badgeType === void 0 ? 'vertical' : _ref$badgeType,
    _ref$badgeSize = _ref.badgeSize,
    badgeSize = _ref$badgeSize === void 0 ? 'medium' : _ref$badgeSize,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en_US' : _ref$locale;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleLinkedInLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "linkedin-badge",
    className: "LI-profile-badge linkedin-badge-embed-mdx",
    "data-version": "v1",
    "data-size": badgeSize,
    "data-locale": locale,
    "data-type": badgeType,
    "data-theme": theme,
    "data-vanity": username
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "LI-simple-link",
    href: "https://uk.linkedin.com/in/".concat(username, "?trk=profile-badge")
  }, "Loading")));
};
exports.LinkedInBadge = LinkedInBadge;